<template>
  <div class="clear-both"></div>
  <div class="container">
    <div class="row">
      <div class="flex justify-between">
        <div class="w-1/2 p-4">
          <h2>ApiDomains</h2>
          <div v-for="(link, key) in apiDomains" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">Link {{ key + 1}}</label>
              <input :id="'input-' + key" type="text" v-model="apiDomains[key]" class="form-input"/>
            </div>
          </div>
          <h2 class="mt-5">Tracking Domains</h2>
          <div v-for="(link, key) in trackingDomains" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">Domain {{ key + 1}}</label>
              <input :id="'input-' + key" type="text" v-model="trackingDomains[key]" class="form-input"/>
            </div>
          </div>
          <h2 class="form-label mt-5">tutorialUrl</h2>
          <input type="text" v-model="tutorialUrl" class="form-input"/>
          <h2 class="form-label mt-5">copyDownloadLink</h2>
          <input type="text" v-model="copyDownloadLink" class="form-input"/>
          <h2 class="form-label mt-5">tutorialPageTwoImage</h2>
          <input type="text" v-model="tutorialPageTwoImage" class="form-input"/>
          <h2 class="form-label mt-5">tutorialPageThreeImage</h2>
          <input type="text" v-model="tutorialPageThreeImage" class="form-input"/>
          <h2 class="form-label mt-5">tutorialPageFiveImage</h2>
          <input type="text" v-model="tutorialPageFiveImage" class="form-input"/>
          <h2 class="form-label mt-5">tutorialPageSixImage</h2>
          <input type="text" v-model="tutorialPageSixImage" class="form-input"/>
          <h2 class="form-label mt-5">tutorialPageSevenImage</h2>
          <input type="text" v-model="tutorialPageSevenImage" class="form-input"/>
          <h2 class="form-label mt-5">tutorialPageEightImage</h2>
          <input type="text" v-model="tutorialPageEightImage" class="form-input"/>
          <h2 class="form-label mt-5">tutorialPageNineImage</h2>
          <input type="text" v-model="tutorialPageNineImage" class="form-input"/>
          <h2 class="form-label mt-5">turorialGuideVideoUrl</h2>
          <input type="text" v-model="turorialGuideVideoUrl" class="form-input"/>
          <loading-button :loading="loading" @click="submitLink" class="mt-5 btn-indigo ml-auto">
            Save Api Domains
          </loading-button>
        </div>
        <div class="w-1/2 p-4">
          <pre>{{ jsonString }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {Head} from "@inertiajs/vue3";
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
  },
  props: {
    config: Object,
    guid: String,
    appName: String,
  },
  layout: Layout,
  data() {
    return {
      loading: false,
      guid: this.guid,
      apiDomains: this.config.apiDomains,
      trackingDomains: this.config.trackingDomains,
      tutorialUrl: this.config.tutorialPages.tutorialUrl,
      copyDownloadLink:this.config.tutorialPages.copyDownloadLink,
      tutorialPageTwoImage:this.config.tutorialPages.tutorialPageTwoImage,
      tutorialPageThreeImage:this.config.tutorialPages.tutorialPageThreeImage,
      tutorialPageFiveImage:this.config.tutorialPages.tutorialPageFiveImage,
      tutorialPageSixImage:this.config.tutorialPages.tutorialPageSixImage,
      tutorialPageSevenImage:this.config.tutorialPages.tutorialPageSevenImage,
      tutorialPageEightImage:this.config.tutorialPages.tutorialPageEightImage,
      tutorialPageNineImage:this.config.tutorialPages.tutorialPageNineImage,
      turorialGuideVideoUrl:this.config.tutorialPages.turorialGuideVideoUrl,
      tutorialPagesNew:this.config.tutorialPages.tutorialPagesNew,
    };
  },
  methods: {
    submitLink() {
      this.loading = true;
      axios.post('/api/config/update-batch', {
        data: {
          apiDomains: this.apiDomains,
          trackingDomains: this.trackingDomains,
          tutorialPages: {
            tutorialUrl: this.tutorialUrl,
            copyDownloadLink: this.copyDownloadLink,
            onboardingImage2: this.onboardingImage2,
            purchaseImg1: this.purchaseImg1,
            qrPurchaseImageRight: this.qrPurchaseImageRight,
            qrPurchaseImageLeft: this.qrPurchaseImageLeft,
            qrWechatButtonIcon: this.qrWechatButtonIcon,
            purchasePopupAlipayImage: this.purchasePopupAlipayImage,
            purchasePopupWechatImage: this.purchasePopupWechatImage,
            accountSupportImage: this.config.accountSupportImage,
            tutorialPageTwoImage: this.tutorialPageTwoImage,
            tutorialPageThreeImage: this.tutorialPageThreeImage,
            tutorialPageFiveImage: this.tutorialPageFiveImage,
            tutorialPageSixImage: this.tutorialPageSixImage,
            tutorialPageSevenImage: this.tutorialPageSevenImage,
            tutorialPageEightImage: this.tutorialPageEightImage,
            tutorialPageNineImage: this.tutorialPageNineImage,
            turorialGuideVideoUrl: this.turorialGuideVideoUrl,
            tutorialPagesNew: this.tutorialPagesNew,
          }
        },
        guid: this.guid,
        appName: this.appName
      })
          .then(response => {
            this.loading = false;
            alert(`Update is queued`);
          })
          .catch(error => {
            console.error(`Error saving ${key}:`, error);
            alert(`Failed to save ${key}.`);
          });
    },
    containsImage(text) {
      return text.toLowerCase().includes('image');
    },
    serialize(obj) {
      const result = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] !== 'function') {
            result[key] = obj[key];
          }
        }
      }
      return result;
    }
  },
  mounted() {
    console.log(this.config);
  },
  computed: {
    jsonString() {
      const dataForJson = this.serialize(this.config);
      return JSON.stringify(dataForJson, null, 2);
    }
  }
}
</script>
